// import React from "react";
// import "./TeamcenterImplementation.css";
// import TeamcenterImplementationOverview from "./TeamcenterImplementationOverview";
// import BannerImage from "../../../assets/other_image/implimentation.jpg";
// import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
// import Banner from "../Banner/Banner";
// import FloatingContactUs from "../../floting_contact/FloatingContactUs";
// import { NavLink } from "react-router-dom";
// import { Helmet } from "react-helmet-async";

// const TeamcenterImplementation = () => {
//   return (
    
//     <section className="TeamcenterImplementation-management">
//       <Banner
//         image={BannerImage} // Pass the image for this page
//         heading="Teamcenter Implementation" // Pass the heading text for this page
//       />
//       <div>
//          <FloatingContactUs />
//       </div>

            
//       <TeamcenterImplementationOverview />
//       <section style={{ background: "#f5f7fa" }}>
//         <div className="benefits container">
//           <h4 className="TeamcenterImplementation-page-heading">
//             Unlock the Power :
//           </h4>
//           <h5 className="TeamcenterImplementation-subheading">
//             Discover the Transformative Benefits of Teamcenter Implementation With NexTech!
//           </h5>
//           <p className="plmimplementationparagraph">
//             NexTech Solutions ensures Teamcenter implementation project success
//             and results in real business impact with faster time to value.
//             In-depth Teamcenter Product Knowledge
//           </p>
//           <ul className="custom-bullets">
//             <li>Success criteria aligned with customer business goal</li>
//             <li>Pre-defined solutions aligned with business best practices </li>
//             <li>Reuse of implementation best practices </li>
//             <li>Standard templates based documentation</li>
//             <li>Mutually agreed quality gates and reviews </li>
//             <li>Clearly defined project governance model </li>
//           </ul>
//         </div>
//       </section>

//       <section>
//   <div className="solutions container">
//     <div className="row">
//       {/* Left Section: Teamcenter Solutions */}
//       <div className="col-md-6 col-12">
//         <h4 className="TeamcenterImplementation-page-heading">
//           Teamcenter Solutions
//         </h4>
//         <p className="plmimplementationparagraph">
//           We provide comprehensive end-to-end implementation of Teamcenter
//           solutions, ensuring seamless integration across various platforms,
//           including CAD, CAM, CAE, ECAD, MSO, ERP, Technomatix, MES, and more.
//           Our expertise guarantees that Teamcenter is fully integrated into
//           your production environment, optimizing efficiency and productivity.
//         </p>
//       </div>

//       {/* Right Section: Quick Links */}
//       <div className="col-md-6 col-12">
//         <div className="quick-links">
//           <h4>Quick Links</h4>
//           <ul>
//             <li>
//               <NavLink to={"/teamcenter/mcad-integration/solidwork-integration"}>
//                 Teamcenter Integration for SolidWorks
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/mcad-integration/pro-engineer-integration"}>
//                 Teamcenter Integration for Creo Pro/ENGINEER
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/mcad-integration/catia-integration"}>
//                 Teamcenter Integration for CATIA
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/mcad-integration/autocad-integration"}>
//                 Teamcenter Integration for AutoCAD
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/solidedge-integration"}>
//                 Teamcenter Integration for Solid Edge
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/mcad-integration"}>
//                 MCAD Integration
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/ecad-integration"}>
//                 ECAD Integration
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to={"/teamcenter/business-process-management"}>
//                 Business Process and Change Management
//               </NavLink>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>


//       <section style={{ background: "#f5f7fa" }}>
//         <div className="why-nextech container">
//           <h4 className="TeamcenterImplementation-page-heading">
//             Why NexTech?
//           </h4>
//           <h5 className="TeamcenterImplementation-subheading">
//             For Teamcenter Implementation
//           </h5>
//           <ul className="custom-bullets">
//             <li>
//               In-depth Product Knowledge: We possess extensive knowledge of
//               Teamcenter, ensuring successful implementation aligned with
//               customer business goals.
//             </li>
//             <li>
//               Alignment with Best Practices: Our implementation aligns with
//               industry best practices, incorporating pre-defined solutions and
//               reuse of implementation best practices.
//             </li>
//             <li>
//               Seamless Integration: We offer end-to-end implementation with
//               seamless integration of various systems like
//               CAD/CAM/CAE/ECAD/MSO/ERP
//               /Technomatix/MES, ensuring smooth
//               operation within the production environment.
//             </li>
//             <li>
//               Unique Methodology: Our unique implementation methodology enables
//               competent consultancy, capability development, cross-system
//               integration, customization, and professional analysis, tailored to
//               meet specific data and process management requirements.
//             </li>
//             <li>
//               Comprehensive Support: We provide comprehensive support including
//               tailor-made training, expert support through various channels, and
//               on-site assistance post go-live, ensuring a smooth transition and
//               ongoing operational excellence.
//             </li>
//           </ul>
//         </div>
//       </section>

//       <section>
//         <div className="best-practices container">
//           <h4 className="TeamcenterImplementation-page-heading">
//             Our Unique Teamcenter Implementation Methodology
//           </h4>
//           <ul className="custom-bullets">
//             <li>
//               Our Unique Teamcenter Implementation Methodology ensures seamless
//               integration of Teamcenter into the production environment through
//             </li>
//             <li>
//               Competent consultancy to enable Teamcenter PLM in your
//               organization
//             </li>
//             <li>
//               Teamcenter capability development for your various business
//               requirements
//             </li>
//             <li>Cross-system integration MCAD/ECAD/CAE/ERP/MES/CRM/Legacy</li>
//             <li>
//               Teamcenter customization to meet your unique data and process
//               management requirements
//             </li>
//             <li>
//               Professional analysis and standard template based documentation{" "}
//             </li>
//             <li>
//               Tailor made training at customers' sites or at our training center{" "}
//             </li>
//             <li>Expert support through mail, call and conferencing </li>
//             <li>On-site support after go-live </li>
//           </ul>
//         </div>
//       </section>
//       <Letsgetintouch />
//     </section>
//   );
// };

// export default TeamcenterImplementation;



import React from "react";
import "./TeamcenterImplementation.css";
import TeamcenterImplementationOverview from "./TeamcenterImplementationOverview";
import BannerImage from "../../../assets/other_image/implimentation.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const TeamcenterImplementation = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
      <Helmet>
        <title>Teamcenter Implementation Services in Pune | NexTech PLM</title>
        <meta name="description" content="Get expert Teamcenter implementation services in India. NexTech PLM Solutions in Pune delivers customized, end-to-end Teamcenter deployment, integration & support to streamline your product lifecycle." />
        <meta name="keywords" content="Teamcenter implementation Pune, Teamcenter deployment India, PLM implementation services, Teamcenter setup configuration, Teamcenter installation support, end-to-end Teamcenter" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/teamcenter-implementation" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Teamcenter Implementation Services | NexTech PLM Solutions" />
        <meta property="og:description" content="Accelerate digital transformation with NexTech's Teamcenter implementation services. Expert PLM deployment, CAD & ERP integration, data migration, cloud transition, and customized engineering solutions." />
        <meta property="og:url" content="https://nextechplm.com/teamcenter-implementation" />
        <meta property="og:image" content="https://nextechplm.com/static/media/teamcenter-implementation.e85f70e0db0c39449641.jpg" />
        <meta property="og:image:alt" content="Teamcenter Implementation Services by NexTech PLM Solutions" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Teamcenter Implementation Services | NexTech PLM Solutions" />
        <meta name="twitter:description" content="Accelerate digital transformation with NexTech's Teamcenter implementation services. Expert PLM deployment, CAD & ERP integration, data migration, cloud transition, and customized engineering solutions." />
        <meta name="twitter:image" content="https://nextechplm.com/static/media/teamcenter-implementation.e85f70e0db0c39449641.jpg" />
      </Helmet>

      <section className="TeamcenterImplementation-management">
        <Banner
          image={BannerImage} // Pass the image for this page
          heading="Teamcenter Implementation" // Pass the heading text for this page
        />
        <div>
          <FloatingContactUs />
        </div>

        <TeamcenterImplementationOverview />

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="TeamcenterImplementation-page-heading">
              Unlock the Power :
            </h4>
            <h5 className="TeamcenterImplementation-subheading">
              Discover the Transformative Benefits of Teamcenter Implementation With NexTech!
            </h5>
            <p className="plmimplementationparagraph">
              NexTech Solutions ensures Teamcenter implementation project success
              and results in real business impact with faster time to value.
              In-depth Teamcenter Product Knowledge
            </p>
            <ul className="custom-bullets">
              <li>Success criteria aligned with customer business goal</li>
              <li>Pre-defined solutions aligned with business best practices</li>
              <li>Reuse of implementation best practices</li>
              <li>Standard templates based documentation</li>
              <li>Mutually agreed quality gates and reviews</li>
              <li>Clearly defined project governance model</li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="row">
              {/* Left Section: Teamcenter Solutions */}
              <div className="col-md-6 col-12">
                <h4 className="TeamcenterImplementation-page-heading">
                  Teamcenter Solutions
                </h4>
                <p className="plmimplementationparagraph">
                  We provide comprehensive end-to-end implementation of Teamcenter
                  solutions, ensuring seamless integration across various platforms,
                  including CAD, CAM, CAE, ECAD, MSO, ERP, Technomatix, MES, and more.
                  Our expertise guarantees that Teamcenter is fully integrated into
                  your production environment, optimizing efficiency and productivity.
                </p>
              </div>

              {/* Right Section: Quick Links */}
              <div className="col-md-6 col-12">
                <div className="quick-links">
                  <h4>Quick Links</h4>
                  <ul>
                    <li>
                      <NavLink to={"/teamcenter/mcad-integration/solidwork-integration"}>
                        Teamcenter Integration for SolidWorks
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/mcad-integration/pro-engineer-integration"}>
                        Teamcenter Integration for Creo Pro/ENGINEER
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/mcad-integration/catia-integration"}>
                        Teamcenter Integration for CATIA
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/mcad-integration/autocad-integration"}>
                        Teamcenter Integration for AutoCAD
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/solidedge-integration"}>
                        Teamcenter Integration for Solid Edge
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/mcad-integration"}>
                        MCAD Integration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/ecad-integration"}>
                        ECAD Integration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/business-process-management"}>
                        Business Process and Change Management
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="why-nextech container">
            <h4 className="TeamcenterImplementation-page-heading">
              Why NexTech?
            </h4>
            <h5 className="TeamcenterImplementation-subheading">
              For Teamcenter Implementation
            </h5>
            <ul className="custom-bullets">
              <li>
                In-depth Product Knowledge: We possess extensive knowledge of
                Teamcenter, ensuring successful implementation aligned with
                customer business goals.
              </li>
              <li>
                Alignment with Best Practices: Our implementation aligns with
                industry best practices, incorporating pre-defined solutions and
                reuse of implementation best practices.
              </li>
              <li>
                Seamless Integration: We offer end-to-end implementation with
                seamless integration of various systems like CAD/CAM/CAE/ECAD/MSO/ERP/
                Technomatix/MES, ensuring smooth operation within the production environment.
              </li>
              <li>
                Unique Methodology: Our unique implementation methodology enables
                competent consultancy, capability development, cross-system
                integration, customization, and professional analysis, tailored to
                meet specific data and process management requirements.
              </li>
              <li>
                Comprehensive Support: We provide comprehensive support including
                tailor-made training, expert support through various channels, and
                on-site assistance post go-live, ensuring a smooth transition and
                ongoing operational excellence.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="best-practices container">
            <h4 className="TeamcenterImplementation-page-heading">
              Our Unique Teamcenter Implementation Methodology
            </h4>
            <ul className="custom-bullets">
              <li>
                Our Unique Teamcenter Implementation Methodology ensures seamless
                integration of Teamcenter into the production environment through
              </li>
              <li>
                Competent consultancy to enable Teamcenter PLM in your organization
              </li>
              <li>
                Teamcenter capability development for your various business requirements
              </li>
              <li>Cross-system integration MCAD/ECAD/CAE/ERP/MES/CRM/Legacy</li>
              <li>
                Teamcenter customization to meet your unique data and process
                management requirements
              </li>
              <li>
                Professional analysis and standard template based documentation
              </li>
              <li>
                Tailor made training at customers' sites or at our training center
              </li>
              <li>Expert support through mail, call and conferencing</li>
              <li>On-site support after go-live</li>
            </ul>
          </div>
        </section>

        <Letsgetintouch />
      </section>
    </>
  );
};

export default TeamcenterImplementation;
